import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import {
  useDisableHandRaisedSound,
  useEnableHandRaisedSound,
} from "../api/toggle-raised-hand-sound";

export function RaisedHandSoundToggle() {
  const isRaisedHandSoundEnabled = useVidyoStore(
    (state) => state.participants.isRaisedHandSoundEnabled,
  );
  const sessionId = useVidyoStore((state) => state.sessionId);

  const {
    mutateAsync: enableHandRaisedSound,
    isPending: isEnablingHandRaisedSound,
  } = useEnableHandRaisedSound();

  const {
    mutateAsync: disableHandRaisedSound,
    isPending: isDisablingHandRaisedSound,
  } = useDisableHandRaisedSound();

  const handleToggleRaisedHandSound = async () => {
    if (isRaisedHandSoundEnabled) {
      await disableHandRaisedSound({ sessionId: sessionId });
    } else {
      await enableHandRaisedSound({ sessionId: sessionId });
    }
  };

  const isLoading = isEnablingHandRaisedSound || isDisablingHandRaisedSound;

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="enable-raised-hand-sound"
        checked={isRaisedHandSoundEnabled}
        onCheckedChange={handleToggleRaisedHandSound}
        disabled={isLoading}
      />
      <Label htmlFor="enable-raised-hand-sound">Enable raised hand sound</Label>
    </div>
  );
}
